// SortableItem.js (Novo Componente)
import React, { useState } from "react";

import ToggleSwitch from "../../../../CommonComponents/ToggleSwitch/ToggleSwitch";
import ClipPath from "../../../../../assets/icons/ic_clip-path.svg";

import LocationRestrictionsPopup from "./LocationRestrictionsPopup/LocationRestrictionsPopup";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

import "./stylesSortableItem.css";
import EditGameIconPopup from "./EditGameIconPopup/EditGameIconPopup";

const SortableItem = ({
  game,
  index,
  order,
  toggleStatus,
  setRemovingGameData,
  removeGame,
  name,
  etype,
  EditGameIcon,
  columns
}) => {
  const [
    isLocationRestrictionsPopupVisible,
    setLocationRestrictionsPopupVisible,
  ] = useState(false);
  const [isEditGameIconPopupVisible, setEditGameIconPopupVisible] =
    useState(false);

  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: game.game_id });

  const columnsLength = columns.length;

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: "grab",
    filter: game.is_active ? "none" : "opacity(0.8)",
  };

  const handlePopupVisibility = () => {
    setRemovingGameData({ ...game, name: name, etype: etype });
    setLocationRestrictionsPopupVisible(true);
  };

  const onClosePressed = () => {
    setEditGameIconPopupVisible(false);
  };

  return (
    <>
      <LocationRestrictionsPopup
        isVisible={isLocationRestrictionsPopupVisible}
        onClosePressed={setLocationRestrictionsPopupVisible}
        getEventCodesList={removeGame}
        game={game}
        etype={etype}
        name={name}
      />
      <EditGameIconPopup
        isVisible={isEditGameIconPopupVisible}
        onClosePressed={onClosePressed}
        game={game}
        EditGameIcon={EditGameIcon}
      />

      <tr
        ref={setNodeRef}
        style={style}
        {...attributes}
        className={`category-row__game-row-expanded category-row__sortable-item ${
          game.is_active ? "active" : "inactive"
        }`}
      >
        <td {...listeners}>
          <div className="category-row__cell category-row__cell-order">
            <img src={ClipPath} alt="" />
            {order}.{index + 1}
          </div>
        </td>
        <td className="category-row__cell">
          <div className="category-row__cell-image">
            <img src={game.image} alt="" width={40} />
            <EditOutlined onClick={() => setEditGameIconPopupVisible(true)} />
          </div>
        </td>
        <td className="category-row__cell"></td>
        <td className="category-row__cell">{game.name}</td>
        {columnsLength > 6 && <td className="category-row__cell"></td>}
        <td className="category-row__cell">
          <p
            className={`status ${
              game.is_active ? "status-active" : "status-disabled"
            }`}
          >
            {game.is_active ? "Active" : "Disabled"}
          </p>
        </td>
        <td className="category-row__cell">
          <div>
            <ToggleSwitch
              status={game.is_active ? 1 : 0}
              eventCode={{ provider: game.provider }}
              updateEventCode={toggleStatus}
              onlyUpdate={true}
              data={{
                game_id: game.game_id,
                provider: game.provider,
                name: name,
                etype: etype,
              }}
            />
          </div>
        </td>
        <td
          className="category-row__cell-delete-icon"
          onClick={handlePopupVisibility}
        >
          <DeleteOutlined />
        </td>
      </tr>
    </>
  );
};

export default SortableItem;
